import { useState, useLayoutEffect } from "react";
import { useTheme } from "../ThemeProvider";
import { formatPrecioVentaEntero, parsePrecioVentaEntero } from "../../utils/moneyParse";

const STICKY_TOP = 108;

function textoPrecioDestacado(form) {
  if (form.precio_web_consultar) return "A consultar";
  const pv = parsePrecioVentaEntero(form.precio_venta);
  if (!Number.isFinite(pv) || pv <= 0) return "—";
  return `${formatPrecioVentaEntero(pv)} €`;
}

/**
 * Ancla en el layout de Principales y pinta ref + precio en fixed sin marco,
 * alineados con esa columna y pegados bajo la nav al hacer scroll.
 */
export default function EtiquetasFlotantesPropiedad({ form, onIrAPrecio, anchorRef }) {
  const { theme } = useTheme();
  const c = theme.colors;
  const [pos, setPos] = useState(null);

  const destacadoValor = {
    fontSize: 22,
    fontWeight: 800,
    color: c.textPrimary,
    lineHeight: 1.15,
    letterSpacing: "-0.02em",
  };

  useLayoutEffect(() => {
    const update = () => {
      const el = anchorRef?.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      setPos({
        top: Math.max(STICKY_TOP, r.top),
        left: r.left,
        width: r.width,
      });
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [anchorRef, form.referencia, form.precio_venta, form.precio_web_consultar]);

  if (!pos) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: pos.top,
        left: pos.left,
        width: pos.width,
        textAlign: "right",
        zIndex: 19,
        pointerEvents: "none",
      }}
    >
      <div style={{ ...destacadoValor, color: c.accentGreen, marginBottom: 12, pointerEvents: "auto" }}>
        {form.referencia || "—"}
      </div>
      <div
        role={onIrAPrecio ? "button" : undefined}
        tabIndex={onIrAPrecio ? 0 : undefined}
        title={onIrAPrecio ? "Ir a Precio venta" : undefined}
        onClick={onIrAPrecio ? (e) => { e.preventDefault(); onIrAPrecio(); } : undefined}
        onKeyDown={onIrAPrecio ? (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onIrAPrecio();
          }
        } : undefined}
        style={{
          ...destacadoValor,
          color: form.precio_web_consultar ? c.textMuted : c.textPrimary,
          cursor: onIrAPrecio ? "pointer" : "default",
          transition: "opacity 0.15s ease",
          pointerEvents: "auto",
        }}
        onMouseEnter={onIrAPrecio ? (e) => { e.currentTarget.style.opacity = "0.75"; } : undefined}
        onMouseLeave={onIrAPrecio ? (e) => { e.currentTarget.style.opacity = "1"; } : undefined}
      >
        {textoPrecioDestacado(form)}
      </div>
    </div>
  );
}

/** Columna reservada en Principales para alinear las etiquetas flotantes. */
export function AnclaEtiquetasPropiedad({ anchorRef }) {
  return (
    <div
      ref={anchorRef}
      style={{ flexShrink: 0, minWidth: 148, paddingTop: 2, alignSelf: "flex-start", visibility: "hidden" }}
      aria-hidden="true"
    >
      <div style={{ fontSize: 22, fontWeight: 800, lineHeight: 1.15, marginBottom: 12 }}>&nbsp;</div>
      <div style={{ fontSize: 22, fontWeight: 800, lineHeight: 1.15 }}>&nbsp;</div>
    </div>
  );
}
